<template lang="pug">
b-modal#ticketDetailAffiliate(
  ref="ticketDetailAffiliate"
  :title='$t("ui.ticket_detail_affiliate")'
  centered
  no-fade
  no-close-on-backdrop
  ok-only
  :busy="loading"
  @show="reset"
  @shown="shown"
)
  template(v-if="ticketDetail")
    .clusterize-scroll.table-responsive
      table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
        thead.thead-light
          tr
            th(colspan="2")
              span {{ $t("ui.withdrawal") }}
        tbody
          tr
            td
              span {{ $t("ui.id") }}
            td
              span {{ ticketDetail.id }}
          tr
            td
              span {{ $t("ui.affiliate") }}
            td
              span {{ ticketDetail.account_id }}
          tr
            td
              span {{ $t("ui.amount") }}
            td
              span.font-weight-bold(:title="$n(ticketDetail.amount, 'currency')" :class="$helpers.fontClassName(ticketDetail.amount)") {{ $n(ticketDetail.amount, 'currency') }}
          tr
            td
              span {{ $tc("ui.banks", 1) }}
            td
              span {{ ticketDetail.recipient_bank_id }}
          tr
            td
              span {{ $t("ui.bank_acc_no") }}
            td
              span {{ ticketDetail.recipient_bank_acc_no }}
          tr
            td
              span {{ $t("ui.bank_acc_holder") }}
            td
              span {{ ticketDetail.recipient_bank_acc_holder }}
          tr
            td
              span {{ $t("ui.status") }}
            td
              span(:class="$helpers.ticketStatusWoBadgeClass(ticketDetail.status)") {{ ticketDetail.status.trim().toUpperCase() }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.remark") }}
            td
              span {{ ticketDetail.remark }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.modified_by") }}
            td
              span {{ ticketDetail.modified_by }}
          tr(v-if="ticketDetail.status.trim().toUpperCase() != 'PENDING'")
            td
              span {{ $t("ui.modified_date") }}
            td(v-if="ticketDetail.modified_date")
              span {{ $moment(ticketDetail.modified_date).format("YYYY-MM-DD, HH:mm:ss") }}
          tr
            td
              span {{ $t("ui.created_date") }}
            td(v-if="ticketDetail.created_date")
              span {{ $moment(ticketDetail.created_date).format("YYYY-MM-DD, HH:mm:ss") }}
          template(v-if="ticketDetail.exchange_currency != null")
            tr
              td
                span {{ $t("ui.base_rate") }} ({{ getCurrencyCode }})
              td
                span.font-weight-bold(:title="$n(ticketDetail.base_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.base_rate)") {{ $n(ticketDetail.base_rate, 'currency') }}
            tr
              td
                span {{ $t("ui.exchange_rate") }} ({{ ticketDetail.exchange_currency }})
              td
                span.font-weight-bold(:title="$n(ticketDetail.exchange_rate, 'currency')" :class="$helpers.fontClassName(ticketDetail.exchange_rate)") {{ $n(ticketDetail.exchange_rate, 'currency') }}
            tr
              td
                span {{ $t("ui.exchanged_amount") }}
              td
                span.font-weight-bold(:title="ticketDetail.exchanged_amount" :class="$helpers.fontClassName(ticketDetail.exchanged_amount)") {{ ticketDetail.exchanged_amount }}

    div(slot="modal-footer")
      SubmitButton.float-right(icon="far fa-times-circle" :text="$t('ui.close')" @click="closeModal()" size="sm" variant="primary").mr-1
</template>

<script>
import { required, minLength, maxLength, url } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    DebounceInput
  },
  props: {
    ticketDetail:{
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
    };
  },
  computed: {
    getCurrencyCode() {
      return this.$store.getters.currencyCode;
    }
  },
  mounted: function() {
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {

    },
    closeModal: function() {
      this.$refs.ticketDetailAffiliate.hide();
    },
  }
};
</script>
